import React from 'react';
import MostPopular from '../Home/MostPopular/MostPopular';

const PopularPages = () => {
    return (
        <div className='movie' style={{ marginTop: '100px' }}>
            <MostPopular />
        </div>
    );
};

export default PopularPages;